// The radio's TX start and end sounds (Grey, 2026-10-18: "why isn't there tx start sound and tx end sound built in to admin? I
// can update the sounds and adjust for volume there"): heard by you as you key up and as you let go. Each is a sound on the
// admin side (client/sfx.ts SOUNDS: "radio.tx.start", "radio.tx.end"): an uploaded file plays instead of the built-in one, and
// the admin's mixer sets its level and its delay for everyone. The built-in ones are made here: a rising two-tone chirp to key
// up, a short squelch tail and a low blip to let go.
import { sfxBuiltin, sfxDelay, sfxPlay, sfxVol } from "./sfx.js";
import { registerAudio } from "./voice.js";

let ac: AudioContext | null = null;
const ctx = () => (ac ??= (() => { const a = new AudioContext(); registerAudio(a); return a; })());
const ID = { start: "radio.tx.start", end: "radio.tx.end" } as const;

// play it: the admin's file if there is one, otherwise the built-in. vol: your radio's own volume (0..1)
export function radioTxSound(kind: "start" | "end", vol = 1) {
  if (vol <= 0) return;
  if (sfxPlay(ID[kind], null, vol)) return;
  radioSynth(ctx(), kind, vol * sfxVol(ID[kind]), Math.max(0, sfxDelay(ID[kind]) / 1000));
}
export function radioSynth(a: BaseAudioContext, kind: "start" | "end", gain: number, delay: number) {
  if (gain <= 0) return;
  try {
    const t = a.currentTime + 0.01 + delay, out = a.createGain(); out.gain.value = gain; out.connect(a.destination);
    const tone = (f: number, at: number, len: number, level: number) => {
      const o = a.createOscillator(), g = a.createGain(); o.type = "sine"; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, at); g.gain.exponentialRampToValueAtTime(level, at + 0.006); g.gain.setValueAtTime(level, at + len - 0.012); g.gain.exponentialRampToValueAtTime(0.0001, at + len);
      o.connect(g).connect(out); o.start(at); o.stop(at + len + 0.01);
    };
    if (kind === "start") { tone(1050, t, 0.045, 0.12); tone(1500, t + 0.055, 0.05, 0.12); return; }
    // the squelch: a burst of band-passed noise, falling away, then a low blip
    const n = Math.floor(a.sampleRate * 0.12), buf = a.createBuffer(1, n, a.sampleRate), d = buf.getChannelData(0);
    for (let i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / n);
    const src = a.createBufferSource(), bp = a.createBiquadFilter(), g = a.createGain(); src.buffer = buf; bp.type = "bandpass"; bp.frequency.value = 2400; bp.Q.value = 0.8; g.gain.value = 0.16;
    src.connect(bp).connect(g).connect(out); src.start(t);
    tone(820, t + 0.12, 0.06, 0.1);
  } catch { /* no audio here */ }
}
// the admin's ▶ preview of the built-in ones
sfxBuiltin(ID.start, () => radioSynth(ctx(), "start", sfxVol(ID.start), 0));
sfxBuiltin(ID.end, () => radioSynth(ctx(), "end", sfxVol(ID.end), 0));
